// store/alertStore.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAlertStore = defineStore('alerts', () => {
  const visible = ref(false);
  const message = ref('');
  const type = ref<'success' | 'error' | 'info' | 'warning'>('info');
  const timeout = ref(4000);

  const showAlert = (msg: string, alertType: typeof type.value = 'info', duration = 4000) => {
    message.value = msg;
    type.value = alertType;
    timeout.value = duration;
    visible.value = true;
  };

  const closeAlert = () => {
    visible.value = false;
  };

  return {
    visible,
    message,
    type,
    timeout,
    showAlert,
    closeAlert,
  };
});
